import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authSuccessAction } from '../../../state/actions/creators/auth.actioncreator';
import { dispatchGW1Action } from '../../../state/actions/creators/app.actioncreator';
import getPayload from '../../../helpers/jwt.helper';

/* eslint func-names: 0 */
/* eslint default-case: 0 */
/* eslint react/prop-types: 0 */
/* eslint no-case-declarations: 0 */
/* eslint no-shadow: 0 */

const initialize = () => ({ type: 'APP_INITIALIZE' });

class MessageReceiver extends React.Component {
  constructor(props) {
    super(props);
    const { history, authSuccessAction, dispatchGW1Action } = this.props;

    window.onmessage = function (e) {
      const { data } = e;
      if (data) {
        try {
          const message = JSON.parse(data);
          const { action, data: messageData } = message;
          switch (action) {
            case 'route': {
              const { url, token } = messageData;
              const gioweb1Payload = getPayload(token);
              const gw2Token = localStorage.getItem('token');
              const gioweb2Payload = getPayload(gw2Token);
              let validRouting = true;
              if (gioweb1Payload && gioweb2Payload) {
                const { dominio: dominioGW1, username: usernameGW1 } = gioweb1Payload;
                const { dominio: dominioGW2, username: usernameGW2 } = gioweb2Payload;
                if (dominioGW1 !== dominioGW2 || usernameGW1 !== usernameGW2) {
                  validRouting = false;
                }
              }
              if (validRouting === true) {
                history.replace(url);
              } else {
                history.replace('/gw1/token/invalido');
              }
              break;
            }
            case 'auth':
              const { auth } = messageData;
              const { token, user } = auth;
              authSuccessAction(token, user, null);
              initialize();
              break;
            case 'dispatch':
              const { type, payload } = messageData;
              dispatchGW1Action(type, payload);
              break;
          }
        } catch (exception) {}
      }
    };
  }

  render() {
    return <div />;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      authSuccessAction,
      dispatchGW1Action,
      initialize,
    }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps,
)(withRouter(MessageReceiver));
